import { Context } from '@vue-storefront/core';

export const logout = async (
  context: Context
): Promise<void> => {
  const {
    $sapcc: {
      api: { OAuthUserRevoke }
    }
  } = context;

  await OAuthUserRevoke();
};
